module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funreport-title"
  }, [_c('div', {
    staticClass: "animal"
  }, [_c('div', {
    staticClass: "ch"
  }, [_c('img', {
    attrs: {
      "src": _vm.funreport.pic.replace('animal.png', 'animalName.png').replace('../', './')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "en"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-4231e524!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/funHead.vue
// module id = 130
// module chunks = 2